import React from 'react';

export const BlankStateReminders = (props) => (
  <svg
    fill="none"
    height="151"
    viewBox="0 0 191 151"
    width="191"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.3805 149.785C11.0321 149.785 12.371 148.466 12.371 146.838C12.371 145.211 11.0321 143.892 9.3805 143.892C7.7289 143.892 6.39001 145.211 6.39001 146.838C6.39001 148.466 7.7289 149.785 9.3805 149.785Z"
      fill="#7C38E2"
    />
    <path
      d="M58.2829 141.881H50.4163V149.632H58.2829V141.881Z"
      fill="#FF4F4F"
    />
    <path
      d="M50.4617 150C52.1133 150 53.4522 148.68 53.4522 147.053C53.4522 145.426 52.1133 144.106 50.4617 144.106C48.8101 144.106 47.4712 145.426 47.4712 147.053C47.4712 148.68 48.8101 150 50.4617 150Z"
      fill="#7C38E2"
    />
    <path
      clipRule="evenodd"
      d="M51.732 0L34.1621 27.0238L71.9081 12.7357L51.732 0Z"
      fill="#F1F1F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M73.3726 14.6221L33.1348 29.8534L0 80.8176L108.559 149.343L160.424 69.5707L73.3726 14.6221Z"
      fill="#F1F1F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M138.528 43.1155L138.68 43.2699L136.491 38.0742L115.763 58.1809L111.037 69.4034L138.528 43.1155Z"
      fill="#7C38E2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M136.401 37.8596L133.832 31.7598L120.421 47.1223L116.194 57.1595L136.248 37.706L136.401 37.8596Z"
      fill="#7C38E2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M133.573 31.3967L133.738 31.5373L130.361 23.5195L120.958 45.8467L133.573 31.3967Z"
      fill="#7C38E2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M156.931 86.6064L138.77 43.4844L110.614 70.4085L103.792 86.6064L77.2224 149.693H130.361H183.501L156.931 86.6064Z"
      fill="#7C38E2"
      fillRule="evenodd"
    />
    <path d="M1.70618 149.692H189.747" stroke="#2F1359" />
    <path
      clipRule="evenodd"
      d="M141.492 109.859L123.041 133.633V143.16L147.124 109.859H141.492Z"
      fill="#4E3672"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M133.564 109.859L123.041 122.373V132.924L140.942 109.859H133.564Z"
      fill="#4E3672"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M132.997 109.859H123.041V121.698L132.997 109.859Z"
      fill="#4E3672"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M147.66 109.859L123.041 143.902V149.692H184.226V109.859H147.66Z"
      fill="#4E3672"
      fillRule="evenodd"
    />
    <path
      d="M173.737 104.261C183.271 104.261 191 96.646 191 87.2518C191 77.8577 183.271 70.2422 173.737 70.2422C164.203 70.2422 156.474 77.8577 156.474 87.2518C156.474 96.646 164.203 104.261 173.737 104.261Z"
      fill="#2F1359"
    />
    <path
      d="M176.359 109.859H181.604V100.601H176.359V109.859Z"
      fill="#2F1359"
    />
    <path
      d="M165.871 109.859H171.115V100.601H165.871V109.859Z"
      fill="#2F1359"
    />
    <path
      d="M177.233 111.582C179.647 111.582 181.604 110.859 181.604 109.967C181.604 109.076 179.647 108.353 177.233 108.353C174.82 108.353 172.863 109.076 172.863 109.967C172.863 110.859 174.82 111.582 177.233 111.582Z"
      fill="#2F1359"
    />
    <path
      d="M166.745 111.366C169.158 111.366 171.115 110.643 171.115 109.752C171.115 108.86 169.158 108.137 166.745 108.137C164.331 108.137 162.374 108.86 162.374 109.752C162.374 110.643 164.331 111.366 166.745 111.366Z"
      fill="#2F1359"
    />
    <path
      d="M173.3 88.7587C176.559 88.7587 179.2 86.1559 179.2 82.9453C179.2 79.7346 176.559 77.1318 173.3 77.1318C170.042 77.1318 167.4 79.7346 167.4 82.9453C167.4 86.1559 170.042 88.7587 173.3 88.7587Z"
      fill="white"
    />
    <path
      d="M173.3 84.8834C174.386 84.8834 175.267 84.0158 175.267 82.9456C175.267 81.8754 174.386 81.0078 173.3 81.0078C172.214 81.0078 171.333 81.8754 171.333 82.9456C171.333 84.0158 172.214 84.8834 173.3 84.8834Z"
      fill="#4E3672"
    />
    <path
      clipRule="evenodd"
      d="M190.483 71.433C191.877 65.282 187.421 59.0668 180.531 57.5508C173.64 56.0348 166.925 59.7922 165.531 65.9431C164.137 72.0941 168.703 74.3626 175.594 75.8786C182.484 77.3946 189.089 77.5839 190.483 71.433Z"
      fill="#7C38E2"
      fillRule="evenodd"
    />
    <path d="M38.9121 84.8838V149.693" stroke="#2F1359" />
    <path
      d="M77.1526 59.9072H0.671631V109.86H77.1526V59.9072Z"
      fill="#7C38E2"
    />
    <path d="M68.4118 72.3955H9.41223V74.118H68.4118V72.3955Z" fill="#F1F1F1" />
    <path d="M68.4118 78.209H9.41223V79.9315H68.4118V78.209Z" fill="#F1F1F1" />
    <path d="M68.4118 84.0225H9.41223V85.745H68.4118V84.0225Z" fill="#F1F1F1" />
    <path
      d="M68.4119 95.6494H53.1157V97.3719H68.4119V95.6494Z"
      fill="#F1F1F1"
    />
    <path
      d="M38.9121 63.3519C42.5326 63.3519 45.4676 61.8095 45.4676 59.9069C45.4676 58.0043 42.5326 56.4619 38.9121 56.4619C35.2916 56.4619 32.3566 58.0043 32.3566 59.9069C32.3566 61.8095 35.2916 63.3519 38.9121 63.3519Z"
      fill="#4E3672"
    />
  </svg>
);
